<script setup lang="ts">
import Hero from '@/domains/investor/components/Hero/Hero.vue'
import type { IProps } from './Hero.types'

const localePath = useLocalePath()
const pathToPage = localePath('for-investors-corporate-governance-supervisory-board')
defineProps<IProps>()
</script>

<template>
  <Hero
    :title="title"
    :lead="lead"
    :second-category="{
      label: title,
      url:  $t('investor.corporateGovernance.supervisor.hero.secondCategory.url'),
      aria:  $t('investor.corporateGovernance.supervisor.hero.secondCategory.aria', { member: title})
    }"
    :main-category="{
      label: $t('investor.corporateGovernance.supervisor.hero.mainCategory.label'),
      url:  pathToPage,
      aria: $t('investor.corporateGovernance.supervisor.hero.mainCategory.aria')
    }"
    :first-button="{
      text: $t('investor.corporateGovernance.supervisor.hero.firstButton.label'),
      to: $t('investor.corporateGovernance.supervisor.hero.secondCategory.url'),
    }"
  />
</template>
